<template>
  <div class="className">
    <el-card class="anoCard">
      <div class="searchDiv" style="padding-top: 10px">
        <el-form
          ref="form"
          :inline="true"
          label-position="right"
          label-width="100px"
          :model="queryForm"
          @submit.native.prevent
        >
          <el-form-item label="电台名称">
            <el-input
              v-model="queryForm.name"
              placeholder="请输入电台名称"
              style="width: 220px"
              clearable
            />
          </el-form-item>
          <el-form-item label="创建日期">
            <el-date-picker
              v-model="queryForm.dateRange"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
              @change="dateChange"
              clearable
          >
          </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button @click="handleQuery" type="primary" icon="el-icon-download">下载</el-button>
            <el-button
              icon="el-icon-search"
              native-type="submit"
              type="primary"
              @click="handleQuery"
            >
              查询
            </el-button>
            <el-button @click="handleAdd" icon="el-icon-plus" v-hasPermi="['Island:radiomanage:add']" type="success">新增</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="tableCard">
      <el-table
        :data="tableData"
        style="width: 100%; margin-bottom: 20px"
        border
      >
        <el-table-column
          align="center"
          label="序号"
          width="80"
          type="index"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="电台编号"
          prop="id"
          height="500"
        />
        <el-table-column
          align="center"
          label="电台名称"
          prop="finish_time"
         
          width="180"
        >
          <template #default="{ row }">
            <p>{{ row.name }}</p>
          </template>
        </el-table-column>
        <el-table-column align="center" prop="translate_type_name" label="分类">
        </el-table-column>
        <el-table-column align="center" prop="finish_time" label="已解锁图片">
          <template #default="{ row }">
            <!-- <img class="img-style" :src="row.lock_pic" alt=""/> -->
            <el-image 
              style="width: 100px; height: 100px"
              :src="row.lock_pic" 
              v-if="row.lock_pic"
              :preview-src-list="[row.lock_pic]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column align="center" label="未解锁图片">
          <template #default="{ row }">
            <!-- <img class="img-style" :src="row.unlock_pic" alt=""/> -->
             <el-image 
              style="width: 100px; height: 100px"
              :src="row.unlock_pic"
              v-if="row.unlock_pic"
              :preview-src-list="[row.unlock_pic]">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="音频文件"
        >
          <template #default="{ row }">
            <a :href="row.audio_file" download="true" target="_blank" style="color: #409eff;">预览</a>
            <!-- <span @click="downloads(row.audio_file)" style="color: #409eff; cursor: pointer;">预览</span> -->
            <!-- <a @click="downloadAudio(row.audio_file)" style="color: #409eff;">下载</a> -->
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="歌词文件"
        >
          <template #default="{ row }">
            <a :href="row.lyric_file" download="true" target="_blank" style="color: #409eff;">下载</a>
            <!-- <span @click="downloads(row.audio_file)" style="color: #409eff; cursor: pointer;">预览</span> -->
            <!-- <a @click="downloadAudio(row.audio_file)" style="color: #409eff;">下载</a> -->
          </template>
        </el-table-column>
        <el-table-column align="center" prop="user_num" label="已解锁用户数量" >
        </el-table-column>
        <el-table-column align="center"  label="创建日期">
          <template #default="{ row }">
            <span>{{ transTime(row.insert_time) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="排序"
          prop="order_by"
        >
        </el-table-column>
        <el-table-column
          align="center"
          label="状态"
         >
         <template #default="{ row }">
            <span v-if="row.status == 1">上架</span>
            <span v-if="row.status == 0">下架</span>
          </template>
         </el-table-column>
        <el-table-column align="center" label="操作">
          <template #default="{ row }">
            <el-button
              size="small"
              type="primary"
              @click="edit(row)"
              v-hasPermi="['Island:radiomanage:edit']"
            >
              编辑
            </el-button>
            <el-button
              size="small"
              type="danger"
              @click="delet(row)"
              v-hasPermi="['Island:radiomanage:delete']"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        :current-page="queryForm.page"
        :layout="layout"
        :page-size="queryForm.pageSize"
        :total="total"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
      />
    </el-card>
  </div>
</template>

<script>
import { getTranslateList, delTranslate } from "@/api/radio";
import axios from "axios"
import { transTime } from "@/utils/transTime"
import { getImgName } from '@/utils/cutImgName'

export default {
  data() {
    return {
      getImgName,
      transTime,
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一年',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      queryForm: {
        page: 1,
        pageSize: 10,
        name: '',
        timeRange: "0", // 时间范围(默认是查询2小时内的数据)
        dateRange: [], // 时间段
      }, // 搜索条件表单
      dialogVisible: false, // 模态框是否展示
      dialogForm: {}, // 模态框展示的数据
      layout: "total, sizes, prev, pager, next, jumper", // 分页数据
      total: 0, // 总数据条数
      tableData: [],
      start: '',
      end: ''
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {},

  methods: {
    dateChange(val){
      if(val){
        const [start, end] = val
        this.start = start
        this.end = end
      } else {
        this.start = ''
        this.end = ''
      }
    },
    // 每页条目数改变事件
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.fetchData();
    },
    // 页改变事件
    handleCurrentChange(val) {
      this.queryForm.page = val;
      this.fetchData();
    },
    handleQuery() {
      // 查询
      this.queryForm.page = 1;
      // 查询（3:近一周，4:近一月，这两个情况下，必须要写订单号，否则报错）
      const { timeRange } = this.queryForm;
      this.fetchData();
    },
    handleAdd(){
      this.$router.push({
        path: "/radioAdd",
        query: { 
          type: 'add',
          length: this.tableData.length ? this.tableData[0].order_by : 0
        },
      })
    },
    delet(row){
      this.$confirm('确认删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delTranslate({id: row.id}).then(res => {
          console.log(res)
          if(res && res.code){
            this.fetchData()
          }
        }).catch(err => {
          if(err.msg == '已有人解锁不可删除'){
            this.$message.error('已有人解锁不可删除')
          }
        })

      }).catch(() => {
      })
    },
    edit(row){
      sessionStorage.setItem('radio', JSON.stringify(row))
      this.$router.push({
        path: "/radioAdd",
        query: { 
          type: 'edit',
          length: this.tableData.length ? this.tableData[0].order_by : 0
        },
      })
    },
    async fetchData() {
      // 这里发请求
      let params = {
        page: this.queryForm.page,
        page_size: this.queryForm.pageSize,
        name: this.queryForm.name,
        start: this.start,
        end: this.end
      };
      await getTranslateList(params)
        .then((res) => {
          if (res && res.code) {
            this.tableData = res.data.data_list
            this.total = res.data.total_record; // 总共数量
          }
        })
        .catch((e) => {
        });
    },
    async downloadAudio(url){
      axios(url, {
        method: "GET",
      })
        .then((response) => response.blob())
        .then((blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "xxx.mp3"); // 设置下载文件的名称
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
        })
        .catch((error) => {
          console.error("Error downloading PDF file: ", error); // 处理下载失败的情况
        });
    },
    downloads(url){
      let name = this.getImgName(url)
      // const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `${name}.mp3`
      a.click()
      window.URL.revokeObjectURL(url)
      // fetch(url)
      //   .then(response => response.blob())  // 将响应转为 Blob
      //   .then(blob => {
      //       // 创建一个临时的下载链接
      //       const link = document.createElement('a');
      //       const objectURL = URL.createObjectURL(blob); // 创建一个对象 URL
      //       link.href = objectURL;
      //       link.download = url.split('/').pop(); // 使用文件名设置下载
      //       document.body.appendChild(link); // 将链接添加到文档中
      //       link.click();  // 触发点击事件下载文件
      //       document.body.removeChild(link); // 下载后移除链接
      //       URL.revokeObjectURL(objectURL); // 清理对象 URL
      //   })
      //   .catch(error => console.error('下载失败:', error))
    }
  },
};
</script>
<style lang="scss" scoped>

.tableCard {
  margin-top: 20px;
}

.el-pagination {
  text-align: center;
  margin-top: 10px;
}
.img-style{
  width: 100px;
  height: 100px;
  object-fit: cover;
}
</style>